// extracted by mini-css-extract-plugin
export default {"w-full":"ProductsDashboard_w-full__l-rE8","row":"ProductsDashboard_row__3lg1X","col":"ProductsDashboard_col__vqt-n","card":"ProductsDashboard_card__BQNyk"};